import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

type ThemeMode = 'light' | 'dark';

interface ThemeContextData {
  theme: ThemeMode;
  toggleTheme: () => void;
  setTheme: (mode: ThemeMode) => void;
}

const ThemeContext = createContext<ThemeContextData>({} as ThemeContextData);

export const ThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [theme, setThemeState] = useState<ThemeMode>('dark');

  useEffect(() => {
    const storedTheme = localStorage.getItem('mirrorlabs:theme') as ThemeMode;
    if (storedTheme) {
      setThemeState(storedTheme);
      document.body.className = `theme-${storedTheme}`;
    } else {
      document.body.className = 'theme-dark';
    }
  }, []);

  const setTheme = (mode: ThemeMode) => {
    setThemeState(mode);
    document.body.className = `theme-${mode}`;
    localStorage.setItem('mirrorlabs:theme', mode);
  };

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
